import React from 'react';
import { Zap, Microscope, Activity } from 'lucide-react';
import SEO from '../components/SEO';
import SpecialtyPageTemplate from '../components/SpecialtyPageTemplate';

const XRayPage = () => {
  const config = {
    badge: "Diagnostic Imaging",
    headline: "Digital X-Ray &",
    headlineItalic: "Radiography.",
    subtext: "State-of-the-art digital radiography delivering instant, high-resolution images for precise diagnosis of bone, chest, and abdominal conditions.",
    image: "/images/services/diagnostics_lab.png",
    imageAlt: "Digital X-Ray at Dr. Suresh Pet Care — Advanced Diagnostic Imaging",
    stats: [
      { value: 8000, suffix: '+', label: 'X-Rays Performed' },
      { value: 99, suffix: '%', label: 'Image Quality Rate' },
      { value: 5, suffix: ' Min', label: 'Result Time' },
      { value: 24, suffix: '/7', label: 'Emergency Access' },
    ],
    services: [
      {
        title: "Skeletal Radiography",
        icon: <Zap size={28} />,
        desc: "High-definition bone and joint X-rays for fracture identification, dysplasia grading, and orthopaedic planning.",
        specs: ["Fracture Assessment", "Hip Dysplasia OFA", "Arthritis Staging", "Spinal Films"],
        color: "from-slate-500/10 to-primary/10"
      },
      {
        title: "Thoracic Imaging",
        icon: <Activity size={28} />,
        desc: "Chest X-rays for cardiac enlargement, pulmonary disease, pneumonia, and thoracic mass staging.",
        specs: ["Cardiac Size", "Lung Fields", "Pleural Effusion", "Tracheal Position"],
        color: "from-primary/10 to-blue-500/10"
      },
      {
        title: "Abdominal Films",
        icon: <Microscope size={28} />,
        desc: "Abdominal radiographs to identify GI obstruction, bladder stones, organomegaly, and abdominal masses.",
        specs: ["GI Obstruction", "Bladder Stones", "Organomegaly", "Foreign Bodies"],
        color: "from-teal-500/10 to-primary/10"
      }
    ],
    sectionTitle: "Our Imaging",
    sectionItalic: "Services.",
    warningTitle: "When Imaging",
    warningItalic: "Is Essential.",
    warningText: "X-ray imaging is the fastest way to get definitive answers for many critical conditions. These signs warrant immediate radiographic evaluation.",
    warnings: [
      { name: "Difficulty Breathing", desc: "Chest X-rays rapidly confirm or rule out pulmonary and cardiac causes.", icon: "🫁" },
      { name: "Limb Trauma", desc: "Fractures and dislocations need radiographic confirmation before treatment.", icon: "🦴" },
      { name: "GI Symptoms", desc: "Vomiting with suspicion of foreign body requires urgent abdominal X-ray.", icon: "⚠️" },
      { name: "Urinary Issues", desc: "Bladder and kidney stones are definitively identified by radiography.", icon: "🔍" },
    ],
    ctaBadge: "Imaging Unit",
    ctaTitle: "The Imaging",
    ctaItalic: "Expertise.",
    ctaText: "Our digital X-ray suite delivers instant, high-resolution diagnostic images, enabling same-day diagnosis and faster treatment decisions in Hyderabad.",
    ctaBtn: "Book X-Ray Appointment",
    seoText: "Digital X-ray and radiography for pets in Hyderabad. Fast diagnostic imaging at Dr. Suresh Pet Care. Bone, chest, and abdominal X-ray for dogs and cats.",
    glowColor: "slate-500"
  };

  return (
    <>
      <SEO 
        title="Digital X-Ray & Radiography"
        description="Advanced digital radiography and X-ray imaging for pets at Dr. Suresh Pet Care, Hyderabad. Fast, precise diagnostic imaging."
        canonical="/x-ray"
      />
      <SpecialtyPageTemplate config={config} />
    </>
  );
};


export default XRayPage;
